import type { InMemoryCacheConfig } from "@apollo/client";
import { Html5Entities } from "html-entities";

const htmlEntities = new Html5Entities();

const CacheConfig: InMemoryCacheConfig = {
  typePolicies: {
    Query: {
      keyFields: [],
      queryType: true,
    },
    TrackingQuery: {
      keyFields: [],
      fields: {
        replay: {
          merge(existing = [], incoming: unknown[]): unknown[] {
            return [...existing, ...incoming];
          },
        },
        locations: {
          merge: true,
        },
        vehicles: {
          merge: true,
        },
      },
    },
    PreferenceQuery: {
      keyFields: [],
    },
    ConfigurationQuery: {
      keyFields: [],
    },
    ConfigSettingType: {
      keyFields: ["key", "name"],
    },
    VehicleType: {
      keyFields: ["id"],
      merge: true,
      fields: {
        fleetNames: {
          read(names: string): string {
            return htmlEntities.decode(names).replaceAll(",", ", ");
          },
        },
        htmlMapTemplate: {
          merge(existing: string, incoming: string): string {
            return existing || incoming;
          },
        },
        locationAddress: {
          read(address: string): string {
            return address.trim();
          },
        },
      },
    },
    VehicleTypeGroupsType: {
      keyFields: ["name"],
      fields: {
        name: {
          read(name: string): string {
            return htmlEntities.decode(name);
          },
        },
      },
    },
    UserPreferenceType: {
      keyFields: ["userId"],
      fields: {
        tabs: {
          merge(existing = [], incoming: unknown[]): unknown[] {
            return [...existing, ...incoming];
          },
        },
      },
    },
    TabPreferenceType: {
      keyFields: ["tabId"],
    },
    TabType: {
      keyFields: ["id"],
    },
    TabFilterType: {
      keyFields: ["id"],
    },
    FilterOptionType: {
      keyFields: ["name", "value"],
      fields: {
        name: {
          read(name: string): string {
            return htmlEntities.decode(name);
          },
        },
      },
    },
    FilterType: {
      keyFields: ["key"],
    },
    ReplayTripType: {
      keyFields: ["startDateTime"],
    },
    VehicleEventType: {
      keyFields: ["id"],
      fields: {
        path: {
          read(path: string): string {
            return `${window.location.origin}/${path}`;
          },
        },
      },
    },
  },
};
export default CacheConfig;
